module.exports = __webpack_public_path__ + "static/media/hero-phone.afb089d8.png";